import React, { useEffect } from 'react';
import { SMALL_SIDEBAR_WIDTH } from '../ContentsSidebar';
import styled from 'styled-components';
import theme from '^/theme';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { getSingleContentId } from '^/utilities/state-util';
import { contentsSelector, PatchContent } from '^/store/duck/Contents';
import * as T from '^/types';
import { ChangeIn3D } from '^/store/duck/Pages';

const Root = styled.div({
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  transitionProperty: 'all',
  transitionDuration: '0.3s',
  transitionTimingFunction: 'linear',
});

const ViewPointWrapper = styled.div({
  display: 'flex',
  zIndex: 240,
  flexShrink: 0,
  background: 'white',
  position: 'absolute',
  transition: 'left 0.3s ease-in-out',
  width: `310px`,
  left: SMALL_SIDEBAR_WIDTH,
  flexDirection: 'column',
  height: '100vh',
  backgroundColor: theme.colors.white[100],
  overflow: 'hidden',
});

export function ViewpointCaptureContentsList() {
  //   const selectedViewpointAlbumId = useViewpointStore(s => s.selectedViewpointAlbumId);
  const state = useStore().getState();
  const dispatch = useDispatch();

  const isIn3D = useSelector((s: T.State) => s.Pages.Contents.in3D);
  const threeDMeshId = getSingleContentId(
    state.Pages,
    state.ProjectConfigPerUser,
    T.ContentType.THREE_D_MESH
  );
  const is3DMeshSelected = contentsSelector.isSelected(state.ProjectConfigPerUser)(threeDMeshId);

  useEffect(() => {
    if (!isIn3D && threeDMeshId) {
      dispatch(ChangeIn3D({ in3D: true }));
    }
    if (!is3DMeshSelected && threeDMeshId) {
      PatchContent({
        content: {
          id: threeDMeshId,
          config: {
            selectedAt: new Date(),
          },
        },
      });
    }
  }, [is3DMeshSelected, isIn3D, threeDMeshId]);

  return (
    <Root>
      <ViewPointWrapper>
        <Outlet />
      </ViewPointWrapper>
    </Root>
  );
}
